import {
    GET_ANALYTICS_FILTERS_REQUEST,
    GET_ANALYTICS_FILTERS_SUCCESS,
    GET_ANALYTICS_FILTERS_FAILURE,
} from "../../../../Constants/actionTypes";

const initialState = {
    filters: [],
    loading: false,
    error: null,
};

const anlayticFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ANALYTICS_FILTERS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case GET_ANALYTICS_FILTERS_SUCCESS:
            return {
                ...state,
                loading: false,
                filters: action.payload.filters,
            };

        case GET_ANALYTICS_FILTERS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default anlayticFilterReducer;
